<template>
  <div class="popularScienceVideo">
    <div class="video_top">
      <img
        src="https://doc.medsky.cn/uploadArticle/popularScienceVideo_pc.png"
      />
      <div class="video_font">
        <div class="font">科普视频</div>
        <el-button class="btn" @click="fileClick"> 上传文件 </el-button>
      </div>
    </div>
    <div v-html="acs"></div>
    <div class="video_info">
      <div class="search">
        <el-input
          v-model="reqObj.title"
          clearable
          placeholder="请输入关键词搜索"
        />
        <el-button class="sreach_btn" size="medium" @click="searchClick">
          搜索
        </el-button>
        <el-button class="reset_btn" size="medium" @click="reactClick">
          重置
        </el-button>
      </div>
      <!-- row_item_4 -->
      <div class="video_list row_item_4" v-if="videoList && videoList.length">
        <div
          class="video_item"
          v-for="item in videoList"
          :key="item.id"
          @click="videoClick(item)"
        >
          <div class="video_top_img">
            <img v-if="item.cover_img" :src="item.cover_img" />
            <img v-else src="../../assets/image/videoDefult.png" />
          </div>
          <div class="title ellipsis_single_2">
            {{ item.title }}
          </div>
          <!-- <div class="author ellipsis_single_1">
            <span>作者：</span>
            <span>{{ item.author }}</span>
          </div> 
          //  时间和浏览量
          <div class="video_bottom">
            <div class="time row" v-if="item.create_time">
              <span class="icon">
                <svg
                  t="1756271777790"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4583"
                  id="mx_n_1756271777792"
                  width="16"
                  height="16"
                >
                  <path
                    d="M1024 512C1024 229.230204 794.769796 0 512 0 229.230204 0 0 229.230204 0 512 0 794.769796 229.230204 1024 512 1024 794.769796 1024 1024 794.769796 1024 512ZM70.62069 512C70.62069 268.232934 268.232934 70.62069 512 70.62069 755.767066 70.62069 953.37931 268.232934 953.37931 512 953.37931 755.767066 755.767066 953.37931 512 953.37931 268.232934 953.37931 70.62069 755.767066 70.62069 512ZM512.015395 476.689655C521.717389 476.689655 529.655172 484.608406 529.655172 494.329432L529.655172 247.187809C529.655172 227.686435 513.846184 211.877464 494.344828 211.877464 474.843471 211.877464 459.034483 227.686435 459.034483 247.187809L459.034483 494.329432C459.034483 523.649148 482.752565 547.310345 512.015395 547.310345L759.157018 547.310345C778.658392 547.310345 794.467363 531.501356 794.467363 512 794.467363 492.498644 778.658392 476.689655 759.157018 476.689655L512.015395 476.689655Z"
                    fill="#000000"
                    p-id="4584"
                  ></path>
                </svg>
              </span>
              <span class="time_info">
                {{ item.create_time.split(" ")[0] }}
              </span>
            </div>
            <div class="click_num row" v-if="item.click_num">
              <span class="icon">
                <svg
                  t="1756802009061"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5002"
                  width="20"
                  height="20"
                >
                  <path
                    d="M515.2 224c-307.2 0-492.8 313.6-492.8 313.6s214.4 304 492.8 304 492.8-304 492.8-304S822.4 224 515.2 224zM832 652.8c-102.4 86.4-211.2 140.8-320 140.8s-217.6-51.2-320-140.8c-35.2-32-70.4-64-99.2-99.2-6.4-6.4-9.6-12.8-16-19.2 3.2-6.4 9.6-12.8 12.8-19.2 25.6-35.2 57.6-70.4 92.8-102.4 99.2-89.6 208-144 329.6-144s230.4 54.4 329.6 144c35.2 32 64 67.2 92.8 102.4 3.2 6.4 9.6 12.8 12.8 19.2-3.2 6.4-9.6 12.8-16 19.2C902.4 585.6 870.4 620.8 832 652.8z"
                    p-id="5003"
                  ></path>
                  <path
                    d="M512 345.6c-96 0-169.6 76.8-169.6 169.6 0 96 76.8 169.6 169.6 169.6 96 0 169.6-76.8 169.6-169.6C681.6 422.4 604.8 345.6 512 345.6zM512 640c-67.2 0-121.6-54.4-121.6-121.6 0-67.2 54.4-121.6 121.6-121.6 67.2 0 121.6 54.4 121.6 121.6C633.6 582.4 579.2 640 512 640z"
                    p-id="5004"
                  ></path>
                </svg>
              </span>

              <span> {{ item.click_num }}</span>
            </div>
          </div> -->
        </div>
      </div>
      <el-empty :image-size="200" v-else></el-empty>
      <div class="pages">
        <el-pagination
          :hide-on-single-page="true"
          :page-size="reqObj.limit"
          layout="prev, pager, next"
          :total="total"
          @current-change="changepage"
        >
        </el-pagination>
      </div>
    </div>
    <!-- <el-dialog
      class="dialogModel"
      width="40%"
      :visible.sync="dialogVisibleImg"
      title="上传文件"
      custom-class="dialog_box"
    >
      <el-form
        :model="formInfo"
        :rules="rules"
        ref="ruleForm"
        class="formVideoInfo"
        label-position="top"
      >
        <el-form-item label="视频标题：" prop="title">
          <el-input v-model="formInfo.title" placeholder="请输入视频标题" />
        </el-form-item>
        <el-form-item label="作者：" prop="author">
          <el-input v-model="formInfo.author" placeholder="请输入作者" />
        </el-form-item>
        <el-form-item label="封面图：" prop="cover_img">
          <el-upload
            :http-request="uploadpic"
            class="avatar-uploader"
            action=""
            :show-file-list="false"
          >
            <div v-if="!isShowCover_img">
              <img
                v-if="formInfo.cover_img"
                :src="formInfo.cover_img"
                class="avatar wow bounceInU"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            <div v-else>
              <el-progress
                :width="85"
                type="circle"
                :percentage="progressPercentCover_img"
              ></el-progress>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频文件：" prop="video_url">
          <el-upload
            :http-request="uploadfile"
            :before-upload="beforeUpload"
            class="avatar-uploader"
            action=""
            :show-file-list="false"
          >
            <div v-if="!isShowfile_path">
              <img
                v-if="formInfo.video_url"
                src="../../assets/image/uploadfile.jpg"
                class="avatar wow bounceInU"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            <div v-else>
              <el-progress
                :width="85"
                type="circle"
                :percentage="progressPercentfile_path"
              ></el-progress>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频介绍：" prop="remarks">
          <TinyMceEditor
            v-model="formInfo.remarks"
            placeholder="请输入视频介绍"
          />
        </el-form-item>
        <el-form-item class="btn_item">
          <el-button class="btn_info" @click="okClick"> 提交 </el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->
    <!-- <videoAddEDit
      :dialogVisibleImg="dialogVisibleImg"
      @success_Click="videoListAsync"
      @close_click="handleClick"
    /> -->
  </div>
</template>
<script>
// 引入七牛云
import * as qiniu from "qiniu-js";
import { sevenCloud } from "../../api/createCenter";
// import TinyMceEditor from "../../components/TinyMCE.vue";
import videoAddEDit from "../../components/videoAddEDit.vue";
import { getUser } from "../../utils/localstore";
import videoApi from "../../api/popularScienceVideo";
export default {
  name: "popularScienceVideo",

  data() {
    return {
      acs: "",
      dialogVisibleImg: false,
      total: 0,
      reqObj: {
        title: "",
        page: 1,
        limit: 8,
      },
      videoList: [],
      // formInfo: {
      //   title: "",
      //   author: "",
      //   video_url: "",
      //   cover_img: "",
      //   remarks: "",
      // },
      // rules: {
      //   title: [{ required: true, message: "视频标题必填", trigger: "change" }],
      //   author: [{ required: true, message: "作者必填", trigger: "change" }],
      //   // cover_img: [
      //   //   { required: true, message: "视频封面图必填", trigger: "change" },
      //   // ],
      //   video_url: [
      //     { required: true, message: "视频文件必填", trigger: "change" },
      //   ],
      //   remarks: [
      //     { required: true, message: "视频介绍必填", trigger: "change" },
      //   ],
      // },
      // // 视频地址
      // isShowfile_path: false,
      // progressPercentfile_path: 0,
      // config: {},
      // // 视频封面
      // isShowCover_img: false,
      // progressPercentCover_img: 0,
    };
  },
  created() {
    this.videoListAsync();
    // this.getsevencload();
  },
  methods: {
    changepage(val) {
      console.log(val, "val");
      this.reqObj.page = val;
      this.videoListAsync();
    },
    fileClick() {
      this.$router.push("/videoUpload");
      // if (getUser()) {
      //   this.dialogVisibleImg = true;
      // } else {
      //   this.$message.error("请先登录");
      // }
    },
    handleClick(val) {
      this.dialogVisibleImg = val;
    },
    beforeUpload(rawFile) {
      console.log(rawFile, "rawFile");
      if (rawFile.type.includes("video")) {
        return true;
      } else {
        this.$message.error("请上传视频文件");
        return false;
      }
    },
    uploadfile(el) {
      this.isShowfile_path = true;
      this.upload(el, "video_url");
    },
    uploadpic(el) {
      this.isShowCover_img = true;
      this.upload(el, "cover_img");
    },
    async upload(el, code) {
      await this.getsevencload();
      const that = this;
      const observable = qiniu.upload(el.file, el.file.name, this.config.token);
      const observer = {
        next(res) {
          //上传图片
          if (code === "cover_img") {
            that.progressPercentCover_img = 0;
            that.progressPercentCover_img = Math.trunc(
              Number(((res.total.loaded / res.total.size) * 100).toFixed(2))
            );
          }
          //预览文件
          if (code === "preview_path") {
            that.progressPercentpreview_path = 0;
            that.progressPercentpreview_path = Math.trunc(
              Number(((res.total.loaded / res.total.size) * 100).toFixed(2))
            );
          }
          //上传文件
          if (code === "video_url") {
            // that.formInfo.video_url = Math.round(res.total.size / 1024) + "kB";
            that.progressPercentfile_path = 0;
            that.progressPercentfile_path = Math.trunc(
              Number(((res.total.loaded / res.total.size) * 100).toFixed(2))
            );
          }
        },
        error(err) {
          console.log("失败了吗", err);
          that.$message.error("上传失败");
        },
        complete(res) {
          that.formInfo[code] = that.config.cdn + res.key;
          that.animation();
          that.$message.success("文件上传成功");
        },
      };
      observable.subscribe(observer);
    },

    videoClick(item) {
      this.$router.push(`/popularScienceVideoDetail?id=${item.id}`);
    },
    okClick() {
      this.acs = this.formInfo.remarks;
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.videoUpload(this.formInfo);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    searchClick() {
      this.videoListAsync();
    },
    reactClick() {
      this.reqObj.title = "";
      this.reqObj.page = 1;
      this.videoListAsync();
    },

    async videoListAsync(data = this.reqObj) {
      this.dialogVisibleImg = false;
      try {
        let res = await videoApi.videoList(data);
        if (res.code == 1) {
          this.total = res.data.total;
          this.videoList = res.data.list;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getsevencload() {
      try {
        const res = await sevenCloud();
        if (res.code === 1) {
          this.config = res.data;
          return Promise.resolve();
        }
      } catch (error) {
        console.log(error);
      }
    },
    animation() {
      this.$nextTick(() => {
        new this.$wow.WOW({
          boxClass: "wow",
          animateClass: "animated",
          offset: 0,
          mobile: true,
          live: true,
        }).init();
        this.isShowCover_img = false; //上传图片进度条
        // this.isShowpreview_path = false; //预览文件
        this.isShowfile_path = false; //上传文件
        this.$refs.form.validateField("cover_img"); //上传图片后对表单从新验证
        this.$refs.form.validateField("preview_path"); //预览文件对表单从新验证
        this.$refs.form.validateField("video_url"); //上传文件后对表单从新验证
      });
    },
    async videoUpload(data) {
      try {
        let res = await videoApi.videoUpload(data);
        if (res.code == 1) {
          this.videoListAsync();
          this.$message.success("上传成功");
          this.dialogVisibleImg = false;
          this.formInfo = {
            title: "",
            author: "",
            video_url: "",
            cover_img: "",
            remarks: "",
          };
          this.$refs.ruleForm.resetFields();
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: {
    // TinyMceEditor,
    videoAddEDit,
  },
};
</script>
<style lang="less" scoped>
.formVideoInfo {
  // max-height: 680px;
  max-height: 730px;
  overflow: auto;
}
.avatar-uploader /deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 85px;
  height: 48px;
  line-height: 48px;
  text-align: center;
}
.avatar {
  width: 85px;
  height: 48px;
  display: block;
}
.popularScienceVideo {
  .dialogModel {
    /deep/ .dialog_box {
      border-radius: 10px;
      overflow: hidden;
      margin-top: 4vh !important;
    }
    /deep/ .el-dialog__header {
      background: linear-gradient(180deg, #dbf8ff 0%, #ffffff 100%);
    }
    .btn_item {
      text-align: center;
    }
    .btn_info {
      width: 90px;
      height: 40px;
      background: linear-gradient(136deg, #2fd2c1 0%, #4888fc 100%);
      color: #fff;
      /deep/ span {
        font-size: 17px;
      }
    }
  }

  // padding-top: 500px;
  .video_top {
    position: relative;
    img {
      width: 100%;
    }
    .video_font {
      position: absolute;
      top: 125px;
      left: 191px;
      .font {
        font-size: 60px;
        font-weight: bold;
        color: #000000;
        margin-bottom: 52px;
      }
      .btn {
        // display: inline-block;
        // padding: 14px 24px;
        background: linear-gradient(180deg, #32c9c9 0%, #488afc 100%);
        height: 54px;
        width: 132px;
        border-radius: 6px 6px 6px 6px;
        /deep/ span {
          font-size: 21px;
          color: #ffffff;
          font-weight: 400;
        }
        // cursor: pointer;
      }
    }
  }
  .video_info {
    padding: 0 186px;
    .pages {
      text-align: center;
      margin-top: 62px;
    }
    .search {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 35px;
      .el-input {
        max-width: 445px;
        margin-right: 15px;
      }
      .sreach_btn {
        background-color: #4089e8;
        color: #fff;
      }
      .reset_btn {
        background-color: #34c4cd;
        color: #fff;
      }
    }
  }
  .video_list {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    .video_item:hover {
      transform: scale(102%);
      box-shadow: 0px 3px 20px 1px rgba(0, 0, 0, 0.16);
    }
    .video_item:not(.video_item:nth-child(4n)) {
      // background: red;
      // margin-right: 30px;
    }
    .video_item {
      cursor: pointer;
      max-width: 360px;
      // background:red;
      padding: 15px;
      box-shadow: 0px 0px 10px 1px #eaf1f5;
      margin-bottom: 32px;
      border-radius: 10px;
      .video_top_img {
        max-width: 330px;
        height: 185px;
        border-radius: 10px;
        overflow: hidden;
        img {
          width: 100%;
          // height: 100%;
        }
      }
      .title {
        margin-top: 16px;
        // margin-bottom: 28px;
        font-size: 17px;
        line-height: 25px;
        height: 50px;
      }
      .author {
        height: 20px;
        color: #3b5c75;
        margin-bottom: 23px;
        span:nth-child(1) {
          width: 50px;
          white-space: nowrap;
        }
      }
      .click_num {
        img {
          // transform: scale(0.5);
          width: 15px;
          height: 12px;
          // color: #313131;
        }
      }
      .video_bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .row {
        display: flex;
        align-items: center;
        // flex-wrap: wrap;
        font-size: 16px;
        span:nth-child(1) {
          margin-right: 10px;
        }
        .icon {
          height: 20px;
        }
      }
    }
  }
}
</style>
